import { Navigate } from "react-router";

/** Thin redirect — the schrijven home folded into the unified /oefenen hub.
 *  Kept alive so old bookmarks/deep-links resolve. */
export function SchrijvenHomePage() {
  return <Navigate to="/oefenen?module=schrijven" replace />;
}
